import { useAppSelector } from '@hooks/redux'
import { BreadcrumbItem } from '@interfaces/breadcrumbs'
import {
  Anchor,
  Breadcrumbs,
  Button,
  Group,
  Menu,
  Stack,
  Title,
} from '@mantine/core'
import {
  selectActionsButtonVisible,
  selectActiveSection,
  selectBreadcrumbs,
  selectInviteButtonVisible,
} from '@redux/site/siteSlice'
import { IconChevronDown } from '@tabler/icons-react'

export const ShellHeader = () => {
  const activeSection = useAppSelector(selectActiveSection)
  const breadcrumbs = useAppSelector(selectBreadcrumbs)
  const inviteButtonVisible = useAppSelector(selectInviteButtonVisible)
  const actionsButtonVisible = useAppSelector(selectActionsButtonVisible)

  return (
    <Group
      h="100%"
      px="md"
      align="center"
      justify="space-between"
      wrap="nowrap"
    >
      <Group align="center" wrap="nowrap">
        {activeSection.length > 0 && breadcrumbs.length === 0 && (
          <Title order={3}>{activeSection}</Title>
        )}
        {breadcrumbs.length > 0 && (
          <Breadcrumbs>
            {breadcrumbs.map((item: BreadcrumbItem, index: number) => (
              <Anchor
                href={item.href}
                key={`breadcrumbs-${index}`}
                size="sm"
                c="dark.5"
              >
                {item.title}
              </Anchor>
            ))}
          </Breadcrumbs>
        )}
      </Group>
      <Group align="center">
        {inviteButtonVisible && (
          <Menu shadow="md" width={105}>
            <Menu.Target>
              <Button rightSection={<IconChevronDown size={18} />}>
                Invite
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Contact</Menu.Item>
              <Menu.Item>Staff</Menu.Item>
              <Menu.Item>Partner</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
        {actionsButtonVisible && (
          <Menu shadow="md" width={175} position="bottom-end">
            <Menu.Target>
              <Button rightSection={<IconChevronDown size={18} />}>
                Actions
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Request edit access</Menu.Item>
              <Menu.Item>Send referral</Menu.Item>
              <Menu.Item>Link records</Menu.Item>
              <Menu.Item>Add task</Menu.Item>
              <Menu.Item>Log call</Menu.Item>
              <Menu.Item>Add note</Menu.Item>
              <Menu.Item>Export</Menu.Item>
              <Menu.Item>Print</Menu.Item>
              <Menu.Item>Create contact</Menu.Item>
              <Menu.Item>Create child</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </Group>
    </Group>
  )
}
